import { createAsyncAction } from 'typesafe-actions'
import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as api from '../lib/api/subscriber'
import { AxiosError } from 'axios'
import { updateSubscriberRequestDTO } from '../lib/api/types';

// export type updateSubscribersPayloadType = {
// }

// export type updateSubscribersState= {
//   data:updateSubscribersPayloadType,
//   loading: boolean
//   error: boolean
// }

export const updateSubscribers = createAsyncAction(
  'UPDATE_SUBSCRIBERS_INFO',
  'UPDATE_SUBSCRIBERS_INFO_SUCCESS',
  'UPDATE_SUBSCRIBERS_INFO_FAILURE',
)<updateSubscriberRequestDTO, any, AxiosError>();

type subscribersUpdateAction = ReturnType<typeof updateSubscribers.request>

// const initialState: updateSubscribersState = {
//   data:{},
//   loading:false,
//   error:false,
// }

function* updateSubscribersSaga(action:subscribersUpdateAction):Generator{
  try {
    const response:any = yield call(
      api.updateSubscriber,
      action.payload,
      )
    
    yield put(updateSubscribers.success(response.data))
  } catch (e) {
    yield put(updateSubscribers.failure(e))
  }
}

export function* subscribersUpdateSaga(){
  yield all([takeEvery(updateSubscribers.request, updateSubscribersSaga)])
}